import React, { useState } from 'react'

import { columns } from './columns'
import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../lib/ui/table'
import { useCoachDashboard } from '../CoachDashboardProvider'
import { cn } from '../../../lib/utils'
import { SortIcon } from '../../job_search/AlertsPage/icons'
import TablePagination from '../CandidateActionsRequired/TablePagination'

export function DataTable() {
  const { dashboardData } = useCoachDashboard()
  const [sorting, setSorting] = useState([])
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  const table = useReactTable({
    debugTable: true,
    data: dashboardData.unnotedEvents || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    autoResetPageIndex: false,
    state: {
      pagination,
      sorting,
    },
  })

  const showPagination = dashboardData.unnotedEvents.length > 10
  const totalPages = table.getPageCount()

  return (
    <>
      <div className="rounded-2xl border border-alto-200">
        <Table tableClass="rounded-2xl">
          <TableHeader className="rounded-2xl bg-intoo-green-coachcta">
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow
                key={`${headerGroup.id}-header_group`}
                className="border-alto-200 bg-intoo-green-coachcta p-4 text-white  hover:bg-intoo-green-coachcta sm:px-8 sm:py-6"
              >
                {headerGroup.headers.map((header) => {
                  return (
                    <TableHead
                      key={`${header.id}-header`}
                      className="job-search-table-header h-6 pl-0 text-sm font-bold text-foreground data-[col-id=status]:w-[96px] sm:h-12 sm:px-4 data-[col-id=status]:sm:w-[120px]"
                      data-col-id={header.column.id}
                    >
                      {header.isPlaceholder ? null : (
                        <div
                          className={cn(
                            'flex flex-wrap items-center gap-2',
                            header.column.getCanSort()
                              ? 'cursor-pointer select-none'
                              : '',
                          )}
                          onClick={header.column.getToggleSortingHandler()}
                          title={
                            header.column.getCanSort()
                              ? header.column.getNextSortingOrder() === 'asc'
                                ? 'Sort Ascending'
                                : header.column.getNextSortingOrder() === 'desc'
                                  ? 'Sort Descending'
                                  : 'Clear Sort'
                              : undefined
                          }
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}{' '}
                          {header.column.getCanSort() && <SortIcon />}
                        </div>
                      )}
                    </TableHead>
                  )
                })}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows?.length ? (
              table
                .getRowModel()
                .rows.map((row, index) => (
                  <DataTableRow
                    key={`${row.id}-table_row`}
                    row={row}
                    index={index}
                  />
                ))
            ) : (
              <TableRow className="p-4 sm:px-8 sm:py-6">
                <TableCell colSpan={columns.length + 2} className="h-24">
                  <div className="flex flex-col items-center justify-center">
                    <div className="max-w-96 text-center">
                      <p>You have no upcoming webinars or workshops.</p>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {showPagination && (
          <TablePagination table={table} totalPages={totalPages} />
        )}
      </div>
    </>
  )
}

const DataTableRow = ({ row, ...props }) => {
  const { index } = props
  return (
    <>
      <TableRow
        fred={5}
        className={
          (cn('border-alto-200'),
          index % 2 === 1
            ? 'bg-alto-50 hover:bg-alto-50'
            : '!hover:bg-white !bg-white')
        }
        {...props}
      >
        {row.getVisibleCells().map((cell) => (
          <TableCell
            key={`${row.id}_${cell.id}`}
            className="pb-2 pl-0 pr-0 pt-3 sm:p-4 sm:pr-1"
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        ))}
      </TableRow>
    </>
  )
}
